import { render, staticRenderFns } from "./sliders.vue?vue&type=template&id=24c28182&scoped=true&"
import script from "./sliders.vue?vue&type=script&lang=js&"
export * from "./sliders.vue?vue&type=script&lang=js&"
import style0 from "./sliders.vue?vue&type=style&index=0&id=24c28182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c28182",
  null
  
)

export default component.exports